var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"bg-white d-print-none footer-z-index"},[_c('hr',{staticClass:"border-dark"}),_c('b-row',[_c('b-col',{attrs:{"align":"center"}},[_c('span',{staticClass:"legal text-dark"},[_vm._v("© ASSA ABLOY")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }